import { render, staticRenderFns } from "./detalle_facturas_dia.vue?vue&type=template&id=1f0fcca2&"
import script from "./detalle_facturas_dia.vue?vue&type=script&lang=js&"
export * from "./detalle_facturas_dia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports